export default [
    {
        ligature: "va_channel_video",
        css_class: "va-icon_channel_video",
        unicode: "\\e901",
        html_entity: "&#xe901;",
        description: "channel video",
    },
    {
        ligature: "va_channel_tv",
        css_class: "va-icon_channel_tv",
        unicode: "\\e902",
        html_entity: "&#xe902;",
        description: "channel tv",
    },
    {
        ligature: "va_channel_direct",
        css_class: "va-icon_channel_direct",
        unicode: "\\e903",
        html_entity: "&#xe903;",
        description: "channel direct",
    },
    {
        ligature: "va_channel_dooh",
        css_class: "va-icon_channel_dooh",
        unicode: "\\e904",
        html_entity: "&#xe904;",
        description: "channel dooh",
    },
    {
        ligature: "va_channel_audio",
        css_class: "va-icon_channel_audio",
        unicode: "\\e905",
        html_entity: "&#xe905;",
        description: "channel audio",
    },
    {
        ligature: "va_format_video_web",
        css_class: "va-icon_format_video_web",
        unicode: "\\e900",
        html_entity: "&#xe900;",
        description: "format video web",
    },
    {
        ligature: "va_format_video_app",
        css_class: "va-icon_format_video_app",
        unicode: "\\e906",
        html_entity: "&#xe906;",
        description: "format video app",
    },
    {
        ligature: "va_format_video_ott",
        css_class: "va-icon_format_video_ott",
        unicode: "\\e907",
        html_entity: "&#xe907;",
        description: "format video ott",
    },
    {
        ligature: "va_format_ott_smarttv",
        css_class: "va-icon_format_ott_smarttv",
        unicode: "\\e908",
        html_entity: "&#xe908;",
        description: "format ott smarttv",
    },
    {
        ligature: "va_format_ott_connected_devices",
        css_class: "va-icon_format_ott_connected_devices",
        unicode: "\\e909",
        html_entity: "&#xe909;",
        description: "format ott connected devices",
    },
    {
        ligature: "va_format_ott_gaming_consoles",
        css_class: "va-icon_format_ott_gaming_consoles",
        unicode: "\\e90a",
        html_entity: "&#xe90a;",
        description: "format ott gaming consoles",
    },
    {
        ligature: "va_device_desktop",
        css_class: "va-icon_device_desktop",
        unicode: "\\e90b",
        html_entity: "&#xe90b;",
        description: "device desktop",
    },
    {
        ligature: "va_device_mobile",
        css_class: "va-icon_device_mobile",
        unicode: "\\e90c",
        html_entity: "&#xe90c;",
        description: "device mobile",
    },
    {
        ligature: "va_device_tablet",
        css_class: "va-icon_device_tablet",
        unicode: "\\e90d",
        html_entity: "&#xe90d;",
        description: "device tablet",
    },
    {
        ligature: "va_device_tv",
        css_class: "va-icon_device_tv",
        unicode: "\\e90e",
        html_entity: "&#xe90e;",
        description: "device tv",
    },
    {
        ligature: "va_finish",
        css_class: "va-icon_finish",
        unicode: "\\e90f",
        html_entity: "&#xe90f;",
        description: "finish",
    },
    {
        ligature: "va_completed",
        css_class: "va-icon_completed",
        unicode: "\\e910",
        html_entity: "&#xe910;",
        description: "completed",
    },
];



// WEBPACK FOOTER //
// ./src/IconConstants.js